import { render, staticRenderFns } from "./VTextAreaWithValidation.vue?vue&type=template&id=042eb55a&scoped=true&"
import script from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
export * from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./VTextAreaWithValidation.vue?vue&type=style&index=0&id=042eb55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042eb55a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
